import { matchScoutCondition } from '@modules/scout/matchScoutCondition';
import { SCOUT_CONDITION } from '@modules/scout/scoutCondition';

/**
 * レバウェルスカウト同時登録のVue接続層（薄いmixin）。
 *
 * store から値を集めて純粋関数（matchScoutCondition）へ渡すだけの責務に限定する。
 * 判定ロジック自体は scoutCondition.js / matchScoutCondition.js に集約し、
 * こちらは単体テスト対象にしない。
 *
 * confirmLwScout.twig の v-if / :style / :class から参照する。
 */
export default {
  computed: {
    /**
     * 同時登録ブロックを表示するか（表示条件を満たすか）。
     * @returns {boolean}
     */
    shouldShowScout() {
      const form = {
        prefectureId: Number(this.getStoreValue('form_nt_c1.prefecture_id')),
        licenseTypeId: Number(this.getStoreValue('form_nt_c1.licenses.0.type_id')),
        workstyleTypeId: Number(this.getStoreValue('form_nt_c1.hope_employment_workstyles.0.type_id')),
        jobchangeTypeId: Number(this.getStoreValue('form_nt_c1.hope_jobchanges.0.type_id')),
      };

      return matchScoutCondition(form, SCOUT_CONDITION);
    },

    /**
     * メールアドレスが入力済みかつバリデーションを通過しているか。
     * チェックボックスの活性／非活性の判定に使う。
     * @returns {boolean}
     */
    isScoutEmailValid() {
      return Boolean(
        this.getStoreValue('form_nt_c1.email')
        && this.isValidatePasses('form_nt_c1.email'),
      );
    },

    /**
     * チェックボックスを「チェック済み表示」にするか。
     * メール有効かつ flag が 1 のときのみ true。
     * @returns {boolean}
     */
    isScoutChecked() {
      return this.isScoutEmailValid
        && Number(this.getStoreValue('form_nt_c1.scout_entry_agreed_flag')) === 1;
    },
  },

  watch: {
    // メールアドレスが未入力の状態から入力済みの状態に変わったとき、
    // 同意フラグをデフォルトON(1)に戻す。
    // 一度チェックを外すと flag=0 のまま残り、メールを削除→再入力しても
    // ONに復帰しない不具合を解消するための処理。
    // 対象外LPで flag を作らないよう shouldShowScout でガードする。
    isScoutEmailValid(isFilled) {
      if (isFilled && this.shouldShowScout) {
        this.$store.commit('setValue', {
          'form_nt_c1.scout_entry_agreed_flag': 1,
        });
      }
    },
  },
};
